import useLang from "../../../hooks/useLang";
import SubSection from "../SubSection";
import Label from "../../../components/Label";
import Input from "../../../components/Input";
import Button from "../../../components/Button";

const VariationHotspotsSection = ({
  hotspots,
  handleHotspotChange,
  onDuplicateHotspotCoords,
}) => {
  const lang = useLang();

  return (
    <SubSection>
      <h3>{lang("hotspots")}</h3>
      {hotspots?.map((hotspot) => (
        <div key={hotspot.id} style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              width: "var(--width-6)",
              height: "var(--width-6)",
              backgroundColor: "var(--clr-sky-700)",
              color: "white",
              borderRadius: "var(--width-4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {hotspot.hotspotLabel}
          </div>
          <div style={{ width: "var(--gap)" }} />
          <div style={{ width: "var(--width-20)" }}>
            <Label>{hotspot.label || lang(hotspot.id)}</Label>
          </div>
          <div style={{ width: "var(--width-4)" }}>
            <Label>X</Label>
          </div>
          <div style={{ width: "var(--width-20)" }}>
            <Input
              type="number"
              value={Math.round(hotspot.x * 100) / 100}
              onChange={(e) =>
                handleHotspotChange([
                  { ...hotspot, x: parseFloat(e.currentTarget.value) },
                ])
              }
            />
          </div>
          <div style={{ width: "var(--gap)" }} />
          <div style={{ width: "var(--width-4)" }}>
            <Label>Y</Label>
          </div>
          <div style={{ width: "var(--width-20)" }}>
            <Input
              type="number"
              value={Math.round(hotspot.y * 100) / 100}
              onChange={(e) =>
                handleHotspotChange([
                  { ...hotspot, y: parseFloat(e.currentTarget.value) },
                ])
              }
            />
          </div>
        </div>
      ))}
      <Button onClick={onDuplicateHotspotCoords}>
        {lang("duplicate_to_visible_variations")}
      </Button>
    </SubSection>
  );
};
export default VariationHotspotsSection;
